import type { PreloadFetchPolicy } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import inheritancePopupQuery from '@atlassian/jira-relay/src/__generated__/inheritancePopupQuery.graphql';

type EntryPointParams = { issueId: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';
export const inheritancePopupEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-inheritance-popup" */ './index'),
	),
	getPreloadProps: ({ issueId }: EntryPointParams) => ({
		queries: {
			inheritancePopupQuery: {
				parameters: inheritancePopupQuery,
				variables: { issueId },
				options: {
					fetchPolicy,
				},
			},
		},
	}),
});
